export enum PageType {
  Policy,
  Terms,
  AboutUs,
  EmailTemplate,
  UserGuide,
  TraineeGuide,
  TeamMember,
  Custom
}
